export default "__VITE_ASSET__C4aI7R$L__"